<template>
  <section>
    <v-dialog
      v-model="showDialog"
      width="400px"
      @closed="handleClosed"
      @open="handleOpen">
      <div class="dialog-container">
        <div class="dialog-header">
          <p>{{typeName}} File Details</p>
          <font-awesome-icon
            icon="times"
            class="pointer"
            @click="changeDialog"></font-awesome-icon>
        </div>
        <div class="dialog-body">
          <el-form
            ref="formData"
            :model="formData"
            :rules="rules">
            <span class="name">English</span>
            <el-form-item prop="file">
              <!--              <v-upload-->
              <!--                card-->
              <!--                :notUpload="true"-->
              <!--                hideBtn-->
              <!--                :fileData='{-->
              <!--                  url: formData.url,-->
              <!--                  thumb_url: formData.url-->
              <!--                }'-->
              <!--                :otherData="{-->
              <!--                  option: 'file',-->
              <!--                  url: 'url'-->
              <!--                }"-->
              <!--                @uploadForm="handlerUploadSuccess"></v-upload>-->

              <file-container
                :edit="true"
                :fileData="{
                  url: formData.url,
                  thumb_url: formData.url,
                  client_name:formData.en_client_name
                }"
                :otherData="{
                  option: 'file',
                  url: 'url',
                  target:'en'
                }"
                :not-upload="true"
                is-show-detail
                is-show-doc-name
                @delete="handlerDeleteFile"
                @uploadForm="handlerUploadSuccess" />
            </el-form-item>
            <span class="name">Chinese (Traditional)</span>
            <el-form-item prop="ch_file">
              <!--              <v-upload-->
              <!--                card-->
              <!--                :notUpload="true"-->
              <!--                hideBtn-->
              <!--                :fileData='{-->
              <!--                  url: formData.ch_url,-->
              <!--                  thumb_url: formData.ch_url-->
              <!--                }'-->
              <!--                is-show-detail-->
              <!--                :otherData="{-->
              <!--                  option: 'ch_file',-->
              <!--                  url: 'ch_url'-->
              <!--                }"-->
              <!--                @uploadForm="handlerUploadSuccess"></v-upload>-->

              <file-container
                :edit="true"
                :fileData="{
                  url: formData.ch_url,
                  thumb_url: formData.ch_url,
                  client_name:formData.ch_client_name
                }"
                :otherData="{
                  option: 'ch_file',
                  url: 'ch_url',
                  target:'ch'
                }"
                :not-upload="true"
                is-show-detail
                is-show-doc-name
                @delete="handlerDeleteFile"
                @uploadForm="handlerUploadSuccess" />
            </el-form-item>
            <span>
              <el-form-item
                prop="radioType"
                class="radio">
                <v-radio-group
                  v-model="formData.radioType"
                  :list="radioList"
                  @change="handleRadio"></v-radio-group>
              </el-form-item>
            </span>
            <el-form-item prop="cmnt_dt">
              <v-date-picker
                v-model="formData.cmnt_dt"
                :pickerOptions="pickerOptions"
                :disabled="formData.radioType == 0"></v-date-picker>
            </el-form-item>
          </el-form>
          <div class="btn-list">
            <v-button
              gray
              @click="changeDialog">Cancel</v-button>
            <v-button
              green
              @click="handleSave">Save</v-button>
          </div>
        </div>
      </div>
    </v-dialog>
  </section>
</template>

<script>
export default {
  name: 'InsurerFileUpload',
  props:{
    form:{
      type: Object,
      default: () => {}
    },
    type:{
      type: Number,
      default: 1
    }
  },
  data () {
    const checkFileRequired = (rule, value, cb) => {
      if(!this.form.id && !value){
        cb(new Error(this.$t('placeholder.upload')))
      }
      cb()
    }
    const checkDateRequired = (rule, value, cb) => {
      if(this.formData.radioType == 1 && !value){
        cb(new Error(this.$t('placeholder.select')))
      }
      cb()
    }
    return {
      showDialog: false,
      formData: {
        radioType: 1,
        cmnt_dt: '',
        file: null,
        url: '',
        en_client_name:'',
        ch_file: null,
        ch_url: '',
        ch_client_name:''
      },
      rules:{
        file:[
          {validator: checkFileRequired, trigger: ['change', 'blur']}
        ],
        ch_file:[
          {validator: checkFileRequired, trigger: ['change', 'blur']}
        ],
        cmnt_dt: [
          {validator: checkDateRequired, trigger: ['change', 'blur']}
        ]
      },
      radioList:[
        {
          id: 0,
          name: 'Start Now'
        },
        {
          id: 1,
          name: 'Schedule'
        }
      ],
      pickerOptions: {
        disabledDate(time){
          return time.getTime() < Date.now()
        }
      },
    }
  },
  computed:{
    typeName(){
      return this.type==1?'Brochure':(this.type==2?'Wording':'COVID-19 Extension')
    }
  },
  methods: {
    changeDialog(){
      this.showDialog = !this.showDialog
    },
    handleRadio(val){
      if(val == 0){
        this.formData.cmnt_dt = ''
        this.$refs['formData'].clearValidate(['cmnt_dt'])
      }
    },
    handlerUploadSuccess({ file, result, otherData }){
      const {option, url,target} = otherData
      this.$set(this.formData, url, result.url)
      this.formData[option] = file
      let {name} = file
      if(target=='en'){
        this.formData.en_client_name =name
      }
      else this.formData.ch_client_name =name
      this.$refs['formData'].clearValidate([option])
    },
    handlerDeleteFile(otherData) {
      const { option, url, target } = otherData
      this.$set(this.formData, url, '')
      this.formData[option] = {}
      if(target=='en'){
        this.formData.en_client_name =''
      }
      else this.formData.ch_client_name =''
    },
    handleSave(){
      this.$refs['formData'].validate(valid => {
        if(valid){
          if(this.form && this.form.id){
            // edit
            if(this.formData.file||this.formData.ch_file){
              let params = new FormData()
              params.append('file', this.formData.file)
              params.append('cmnt_dt', this.formData.cmnt_dt)
              params.append('ch_file', this.formData.ch_file)
              params.append('id', this.form.id)
              this.$emit('edit',params)
            }else{
              let params = {
                id: this.form.id,
                cmnt_dt: this.formData.cmnt_dt
              }
              this.$emit('edit', params)
            }
          }else{
            // add
            let params = new FormData()
            params.append('file', this.formData.file)
            params.append('cmnt_dt', this.formData.cmnt_dt)
            params.append('ch_file', this.formData.ch_file)
            this.$emit('save', params)
          }
        }
      })
    },
    handleOpen(){
      let val = this.form
      if(val && val.id){
        this.formData.radioType = 1
        let cmnt_dt = val.cmnt_date
        let arr = cmnt_dt.split('-')
        let date = arr[2]+'-'+arr[1]+'-'+arr[0]
        this.formData.cmnt_dt = date
        this.formData.url = val.file.url
        this.formData.file = null
        this.formData.ch_url = val.ch_file.url
        this.formData.ch_file = null
      }
    },
    handleClosed(){
      this.formData.radioType = 0
      this.formData.cmnt_dt = ''
      this.formData.file = null
      this.formData.url = ''
      this.formData.ch_file = null
      this.formData.ch_url = ''
    }
  },
}
</script>
<style lang='scss' scoped>
.dialog-container{
  .dialog-header{
    height: 20px;
    padding: 16px;
    box-sizing: content-box;
    display: flex;
    justify-content: space-between;
    background: #F6F8FA;
    border: 1px solid #E1E4E8;
    border-radius: 6px 6px 0px 0px;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #1B1F23;
  }
  .dialog-body{
    padding: 20px 15px 15px 15px;
    .name{
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: #24292E;
      margin-bottom: 8px;
      display: block;
    }
    .el-form-item{
      margin-bottom: 20px !important;
    }
    .radio{
      margin-bottom: 0 !important;
    }
    /deep/.el-radio-group{
      display: flex;
      flex-direction: column;
      .el-radio{
        margin-bottom: 6px;
      }
    }
    .btn-list{
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>
